import { cloneDeep } from 'lodash-es'

const STORAGE_KEY = 'viewFiltersState'

function loadFromSession() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {}
  } catch {
    return {}
  }
}

function saveToSession(states) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(states))
}

export default {
  namespaced: true,

  state: () => ({
    states: loadFromSession()
  }),

  getters: {
    getState: (state) => (routeName) => cloneDeep(state.states[routeName]) ?? null
  },

  mutations: {
    SET_STATE(state, { routeName, data }) {
      state.states[routeName] = data
      saveToSession(state.states)
    },
    CLEAR_STATE(state, routeName) {
      delete state.states[routeName]
      saveToSession(state.states)
    }
  }
}
